var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriterLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 160C69.0667 160 58.7333 157.9 49 153.7C39.2667 149.5 30.7667 143.767 23.5 136.5C16.2333 129.233 10.5 120.733 6.3 111C2.1 101.267 0 90.9333 0 80C0 68.9333 2.1 58.5667 6.3 48.9C10.5 39.2333 16.2333 30.7667 23.5 23.5C30.7667 16.2333 39.2667 10.5 49 6.3C58.7333 2.1 69.0667 0 80 0C82.2667 0 84.1667 0.766667 85.7 2.3C87.2333 3.83333 88 5.73333 88 8C88 10.2667 87.2333 12.1667 85.7 13.7C84.1667 15.2333 82.2667 16 80 16C62.2667 16 47.1667 22.2333 34.7 34.7C22.2333 47.1667 16 62.2667 16 80C16 97.7333 22.2333 112.833 34.7 125.3C47.1667 137.767 62.2667 144 80 144C97.7333 144 112.833 137.767 125.3 125.3C137.767 112.833 144 97.7333 144 80C144 77.7333 144.767 75.8333 146.3 74.3C147.833 72.7667 149.733 72 152 72C154.267 72 156.167 72.7667 157.7 74.3C159.233 75.8333 160 77.7333 160 80C160 90.9333 157.9 101.267 153.7 111C149.5 120.733 143.767 129.233 136.5 136.5C129.233 143.767 120.767 149.5 111.1 153.7C101.433 157.9 91.0667 160 80 160Z",
    fill: "url(#paint0_linear_16478_918)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16478_918",
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05062A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50596A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriterLoader);
export default __webpack_public_path__ + "static/media/writer-loader.96b0df79e6b7dbaec1a783c182d1c8c0.svg";
export { ForwardRef as ReactComponent };